import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  };

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  render() {
    return (
      <Map
        style={{ width: "300px", height: "300px", margin: "0px 10px" }}
        google={this.props.google}
        onClick={this.onMapClicked}
      >
        <Marker onClick={this.onMarkerClick} name={"Current location"} />
      </Map>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyBFzFBhjc6v2eSlnR0m31QCanolXKdgN9M",
})(MapContainer);
